import { Skeleton, Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const ContainerStyled = styled(Stack)(() => ({
  alignItems: 'center',
}));
export const SkeletonStyled = styled(Skeleton)(() => ({
  width: 164,
  height: 164,
}));

export const ImageContainerStyled = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: 164,
  height: 164,
}));

export const SercetStyled = styled('div')(() => ({
  backgroundColor: Colors.gray200,
  borderRadius: 8,
  height: 38,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: 164,
}));
